import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zzhiugmthrvzmeyznffd.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6aGl1Z210aHJ2em1leXpuZmZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjExNDQ4OTIsImV4cCI6MjAzNjcyMDg5Mn0.zuIK4-Uwx9moh225qtJzAzDgEYQfE6AmVuwuM3Sanow';

export const supabase = createClient(supabaseUrl, supabaseKey);
